import { render, staticRenderFns } from "./FormatPagePropertyEditor.vue?vue&type=template&id=22ff9a74&scoped=true&"
import script from "./FormatPagePropertyEditor.vue?vue&type=script&lang=ts&"
export * from "./FormatPagePropertyEditor.vue?vue&type=script&lang=ts&"
import style0 from "./FormatPagePropertyEditor.vue?vue&type=style&index=0&id=22ff9a74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ff9a74",
  null
  
)

export default component.exports